import { Profile } from 'src/app/profile/profile.model';
import { StoreService } from './store.service';
import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class ProfileStoreService extends StoreService<Profile> {
  protected store = 'profile';

  constructor() {
    super({}); // Inicializar os valores
  }
}
